import React from "react";

const FilterIconSVG = ({
  width = "20",
  height = "21",
  fill = "none",
  stroke = "#6570FC",
  strokeWidth = "1.5",
  strokeLinecap = "round",
  strokeLinejoin = "round",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3327 3H1.66602L8.33268 10.8833V16.3333L11.666 18V10.8833L18.3327 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap={strokeLinecap}
        strokeLinejoin={strokeLinejoin}
      />
    </svg>
  );
};

export default FilterIconSVG;
